import React from 'react';

const Privacy = () => {
  return (
    <main className="flex-grow container mx-auto px-4 py-8">
      {/* Hero section */}
      <div className="bg-gradient-to-r from-purple-600 to-indigo-800 rounded-xl shadow-lg mb-12 p-8 text-white">
        <h1 className="text-3xl md:text-4xl font-bold mb-4">
          Adatvédelmi tájékoztató
        </h1>
        <p className="text-xl">
          Adatkezelési információk a NIS2 megfelelőségi tanácsadáshoz
        </p>
      </div>

      <div className="bg-gradient-to-br from-purple-100 to-indigo-100 rounded-xl shadow-lg p-8 border border-purple-200">
        <div className="prose prose-purple max-w-none">
          <h2>Adatkezelési tájékoztató</h2>
          
          <p>A Webforyou Kft. (továbbiakban: Adatkezelő) online tevékenységével kapcsolatban kezeli a regisztrált felhasználók személyes adatait, kiemelten figyelmet fordítva az adatok biztonságára és a felhasználók jogainak védelmére. A NIS2 megfelelőségi tanácsadás során különös figyelmet fordítunk az adatvédelmi és információbiztonsági szempontokra.</p>

          <h3>1. Az adatkezelő adatai</h3>
          <ul>
            <li>Cégnév: Webforyou Kft.</li>
            <li>E-mail: nagyroland@webforyou.hu</li>
            <li>Telefon: +36 70 908 3086</li>
          </ul>

          <h3>2. A kezelt adatok köre</h3>
          <p>A NIS2 megfelelőségi tanácsadás során az alábbi személyes adatokat kezeljük:</p>
          <ul>
            <li>Kapcsolattartó neve</li>
            <li>E-mail cím</li>
            <li>Telefonszám</li>
            <li>Cég neve és adatai</li>
            <li>Szervezeti struktúrára vonatkozó információk</li>
            <li>IT infrastruktúrára vonatkozó adatok</li>
            <li>Biztonsági intézkedésekkel kapcsolatos információk</li>
          </ul>

          <h3>3. Az adatkezelés célja</h3>
          <p>Az adatkezelés célja a NIS2 megfelelőségi tanácsadás nyújtása, kockázatértékelés elvégzése, biztonsági intézkedések tervezése, kapcsolattartás és a szolgáltatás teljesítése.</p>

          <h3>4. Az adatkezelés jogalapja</h3>
          <p>Az adatkezelés jogalapja elsősorban a szerződés teljesítése (GDPR 6. cikk (1) bekezdés b) pont), valamint az Ön hozzájárulása (GDPR 6. cikk (1) bekezdés a) pont), amelyet a kapcsolatfelvételi űrlap kitöltésével ad meg.</p>

          <h3>5. Az adatkezelés időtartama</h3>
          <p>A személyes adatokat a tanácsadási szolgáltatás befejezését követő 5 évig, vagy a jogszabályi kötelezettségek teljesítéséhez szükséges ideig őrizzük meg. A NIS2 megfelelőséggel kapcsolatos dokumentációt a jogszabályi előírásoknak megfelelően tároljuk.</p>

          <h3>6. Az Ön jogai</h3>
          <ul>
            <li>Hozzáférési jog - tájékoztatást kérhet az általunk kezelt adatairól</li>
            <li>Helyesbítéshez való jog - pontatlan adatok javítását kérheti</li>
            <li>Törléshez való jog - bizonyos esetekben kérheti adatai törlését</li>
            <li>Adatkezelés korlátozásához való jog - kérheti az adatkezelés korlátozását</li>
            <li>Adathordozhatósághoz való jog - kérheti adatai hordozható formátumban történő kiadását</li>
            <li>Tiltakozáshoz való jog - tiltakozhat az adatkezelés ellen</li>
          </ul>

          <h3>7. Adatbiztonság</h3>
          <p>Az Adatkezelő megfelelő technikai és szervezési intézkedéseket hajt végre annak érdekében, hogy garantálja az Ön személyes adatainak biztonságát. A NIS2 megfelelőségi tanácsadás során szerzett információkat fokozott biztonsági intézkedésekkel védjük, beleértve a titkosítást, hozzáférés-korlátozást és rendszeres biztonsági auditokat.</p>

          <h3>8. NIS2 és adatvédelem</h3>
          <p>A NIS2 irányelv és a GDPR szorosan kapcsolódnak egymáshoz. Tanácsadási szolgáltatásunk során mindkét jogszabály követelményeinek megfelelünk, és segítünk ügyfeleinknek is e kettős megfelelés elérésében. A NIS2 megfelelőségi értékelés során gyűjtött adatokat kizárólag a tanácsadási szolgáltatás nyújtásához és a jogszabályi kötelezettségek teljesítéséhez használjuk fel.</p>

          <h3>9. Kapcsolatfelvétel</h3>
          <p>Adatvédelemmel kapcsolatos kérdéseivel kérjük, forduljon hozzánk bizalommal az alábbi elérhetőségeken:</p>
          <ul>
            <li>E-mail: nagyroland@webforyou.hu</li>
            <li>Telefon: +36 70 908 3086</li>
          </ul>
        </div>
      </div>
    </main>
  );
};

export default Privacy; 